import { OPTION_PAGINATION } from 'constants';

import React, { useCallback, useEffect, useRef, useState } from 'react';

import _ from 'lodash';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import { videoSamplesList } from 'api/endpoints/video-sample';
import { videoCategoryList } from 'api/endpoints/video_category';
import Button from 'components/Button';
import { ENUM_TYPE_VIDEO } from 'constants/enum';
import PopupAddExerciseVideoHeader from 'pages/Users/Detail/_components/PopupAddExerciseVideo/PopupAddExerciseVideoHeader';
import PopupAddExerciseVideoPagination from 'pages/Users/Detail/_components/PopupAddExerciseVideo/PopupAddExerciseVideoPagination';
import PopupAddExerciseVideoTable from 'pages/Users/Detail/_components/PopupAddExerciseVideo/PopupAddExerciseVideoTable';
import { setVideoCategories } from 'store/actions/video-catergory';
import { convertToQueryString } from 'utils/helper';

const PopupAssignTherapist = ({ closePopup, typeVideo, onSelectVideo, originalVideoSelection }) => {
  const dispatch = useDispatch();

  const { me } = useSelector((state) => state.auth);

  const [options, setOptions] = useState({ video_category_id: null, ...OPTION_PAGINATION });
  const [sort, setSort] = useState([]);
  const [listSampleVideo, setListSampleVideo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState([{ page: 1, selected: [] }]);

  const modalRef = useRef(null);

  // PAGINATION
  const onPageChange = (e) => {
    if (e !== options.page) {
      setOptions((prevState) => {
        return { ...prevState, page: e };
      });
      return true;
    }

    return false;
  };

  // SORT
  const onSortChange = (e) => {
    setSort(() => e);
  };

  /**
   * @name handleSort
   * @returns {string[]}
   * @example ['created_at']
   * @example ['-created_at']
   */
  const handleSort = () => {
    return (
      sort.map((item) => {
        return item.desc ? `-${item.id}` : item.id;
      }) || []
    );
  };

  const handleGetSampleVideo = async () => {
    const sortHandle = handleSort().filter((item) => item !== 'link' && item !== '-link');
    const queryString = convertToQueryString({
      video_category_id: options.video_category_id,
      sort_by: sortHandle,
      page: options.page,
      page_size: 10,
      type: typeVideo,
    });
    setLoading(true);
    try {
      const response = await videoSamplesList(queryString);
      setListSampleVideo(response?.data || []);
      setOptions((prevState) => {
        return {
          ...prevState,
          total: response?.total || 0,
          page_size: response?.page_size || 10,
          page: response?.page || 1,
        };
      });
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  // GET DATA
  const getSampleVideo = useCallback(async () => {
    if (me) {
      handleGetSampleVideo();
    }
  }, [options.page, options.video_category_id, sort, me]);

  useEffect(() => {
    getSampleVideo();
  }, [getSampleVideo]);

  const getVideoCategoryList = useCallback(async () => {
    if (me) {
      try {
        const res = await videoCategoryList();
        const data = res.data.map((item) => ({
          label: item.name_vi || item.name,
          value: item.id,
        }));
        dispatch(setVideoCategories(data));
      } catch {
        dispatch(setVideoCategories([]));
      }
    }
  }, [me]);

  useEffect(() => {
    getVideoCategoryList();
  }, [getVideoCategoryList]);

  useEffect(() => {
    document.documentElement.classList.add('overflow-hidden');
    document.documentElement.classList.add('h-screen');

    return () => {
      document.documentElement.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('h-screen');
    };
  }, []);

  const clickBackdrop = () => {
    modalRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  const selectVideo = (selected) => {
    setSelectedVideo(selected);
  };

  const handleSelectVideo = () => {
    let selected = _.flatMap(selectedVideo, (item) => item.selected);
    onSelectVideo(selected);
    closePopup();
  };

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-max">
      <div id="backdrop-modal" onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalRef} className={'bg-white rounded-sm shadow-lg relative max-w-[1616px] w-full modal-content max-h-[98vh] overflow-y-auto'}>
        <div data-testid="header-modal" id="header-modal" className="flex items-start py-4 px-6 border-b border-solid border-gray-651">
          <h2
            className="text-base font-bold text-logo"
            dangerouslySetInnerHTML={{ __html: typeVideo === ENUM_TYPE_VIDEO.DAY ? '運動動画の選択' : '次回の評価動画の選択' }}
          />
        </div>

        <div data-testid="content-modal" id="content-modal" className="p-6">
          <PopupAddExerciseVideoHeader options={options} />
          <div className={'w-full mt-4'}>
            <PopupAddExerciseVideoTable
              data={listSampleVideo}
              setSort={onSortChange}
              reloadData={() => {}}
              onPageChange={onPageChange}
              sort={sort}
              page={options.page}
              onSelectVideo={selectVideo}
              originalVideoSelection={originalVideoSelection}
              loading={loading}
            />
          </div>
          {options.total > 0 && <PopupAddExerciseVideoPagination options={options} onPageChange={onPageChange} loading={loading} center={false} />}
        </div>

        <div data-testid="footer-modal" id="footer-modal" className="px-6 py-4 border-t border-solid border-gray-651 flex justify-end gap-2">
          <Button text={'キャンセル'} color="outline" onClick={closePopup} />
          <Button
            text={typeVideo === ENUM_TYPE_VIDEO.DAY ? '選択動画をユーザーにお勧めする' : '選択動画をユーザーの次回の評価動画とする'}
            color="primary"
            onClick={handleSelectVideo}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default React.memo(PopupAssignTherapist);
